import { api } from './api';
import type { Brand, BrandWithChannels, BrandChannel, BrandCompetitor, BenchmarkMetric } from '../types';

export const brandApi = {
  // Brand CRUD
  list: () => api.get<Brand[]>('/brands'),
  create: (data: Partial<Brand>) => api.post<BrandWithChannels>('/brands', data),
  get: (id: number) => api.get<BrandWithChannels>(`/brands/${id}`),
  update: (id: number, data: Partial<Brand>) => api.patch<Brand>(`/brands/${id}`, data),
  delete: (id: number) => api.delete<{ ok: boolean }>(`/brands/${id}`),

  // Channel CRUD
  addChannel: (brandId: number, data: Partial<BrandChannel>) =>
    api.post<BrandChannel>(`/brands/${brandId}/channels`, data),
  getChannels: (brandId: number) =>
    api.get<BrandChannel[]>(`/brands/${brandId}/channels`),
  updateChannel: (brandId: number, channelId: number, data: Partial<BrandChannel>) =>
    api.patch<BrandChannel>(`/brands/${brandId}/channels/${channelId}`, data),
  deleteChannel: (brandId: number, channelId: number) =>
    api.delete<{ ok: boolean }>(`/brands/${brandId}/channels/${channelId}`),
  setPrimaryChannel: (brandId: number, channelId: number) =>
    api.post<BrandChannel>(`/brands/${brandId}/channels/${channelId}/set-primary`, {}),

  // Competitor CRUD
  getCompetitors: (brandId: number) =>
    api.get<BrandCompetitor[]>(`/brands/${brandId}/competitors`),
  addCompetitor: (brandId: number, data: { username?: string; competitor_brand_id?: number; notes?: string }) =>
    api.post<BrandCompetitor[]>(`/brands/${brandId}/competitors`, data),
  removeCompetitor: (brandId: number, competitorBrandId: number) =>
    api.delete<{ ok: boolean }>(`/brands/${brandId}/competitors/${competitorBrandId}`),

  // Auto-creation flow
  checkAccount: (brandId: number, username: string) =>
    api.post<{ exists: boolean; account_id: number | null }>(`/brands/${brandId}/competitors/check-account`, { username }),
  scrapeCompetitor: (brandId: number, username: string) =>
    api.post<BrandWithChannels>(`/brands/${brandId}/competitors/scrape`, { username }),

  // Benchmark
  getBenchmark: (brandId: number) =>
    api.get<BenchmarkMetric[]>(`/brands/${brandId}/benchmark`),

  // Connection-based channel lookup (for disconnect cascade preview)
  getChannelsByConnection: (connectionId: number) =>
    api.get<BrandChannel[]>(`/brands/channels-by-connection/${connectionId}`),
};
